/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unreachable */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-alert */
import React, { useEffect, useState, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardTitle,
  Button, Label, InputGroup,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Collapse,
  Modal,
} from 'reactstrap';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';
import moment from 'moment';

// Import Scrollbar
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';

import toastr from 'toastr';
import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';
import { Can } from '../../utilities/Can';
import sanitizeTicketHtml from '../../utilities/sanitizeTicketHtml';
import GoogleFiles from '../../components/Common/GoogleFiles';
import 'toastr/build/toastr.min.css';
import { get, post } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';
import Breadcrumbs from '../../components/Common/Breadcrumb';

function Ticket(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;
  const { id } = useParams();
  const textareaRef = useRef(null);

  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [loadingMessage, setLoadingMessage] = useState(false);
  const [loadingAttachment, setLoadingAttachment] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [messageBox, setMessageBox] = useState(null);
  const [messages, setMessages] = useState([]);
  const [messageText, setMessageText] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(null);
  const [subscribers, setSubscribers] = useState([]);
  const [isTagOpen, setIsTagOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [fileCollapse, setFileCollapse] = useState(false);
  const [pendingFiles, setPendingFiles] = useState([]);
  const [attachment, setAttachment] = useState(false);
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [response, setResponse] = useState(null);

  const history = useHistory();

  const toggleTagDropdown = () => {
    setIsTagOpen(!isTagOpen);
  };

  const scrollToBottom = () => {
    if (messageBox) {
      messageBox.scrollTop = messageBox.scrollHeight + 1000;
    }
  };

  const user = JSON.parse(localStorage.getItem('authUser'));

  const fetchTicket = async () => {
    try {
      const ent = await get(url.GET_TICKET.replace(':id', id));

      if (typeof ent !== 'string') {
        setError(null);
        setData(ent);

        const msgs = ent.messages;
        msgs.unshift({
          message: ent.notes,
          from: `${ent.name} from ShopJimmy.com`,
          created_at: ent.created_at,
          attachments: [],
        });
        setMessages(msgs);

        const subs = [];
        setIsSubscribed(false);
        for (let i = 0; i < ent.subscribers.length; i += 1) {
          if (user.id === ent.subscribers[i].user_id) {
            setIsSubscribed(true);
          }

          subs.push(ent.subscribers[i].user);
        }
        setSubscribers(subs);
      } else {
        setError(t('Ticket no longer exists'));
        setData({
          state: 0,
          items: [],
          email: '',
        });
        setMessages([]);
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchTicket();
  }, [refresh, id]);

  useEffect(() => {
    scrollToBottom();
  }, [loadingMessage]);

  useEffect(() => {
    const generateResponse = async () => {
      try {
        const resp = await get(`/api/openai/tech-support/${id}`);
        setResponse(resp.content);
      } catch (err) {
        toastr.error(err.message, 'Error');
      }
    };

    if (data !== null && data.status !== 1) {
      generateResponse(id);
    }
  }, [data]);

  const copyMsg = (ele) => {
    const copyText = ele.closest('.conversation-list').querySelector('p').innerHTML;
    navigator.clipboard.writeText(copyText);
  };

  const unsubscribe = async (usr = null) => {
    if (subscribers.length === 1) {
      toastr.error(t('At least one subscriber is required'));
      return;
    }

    try {
      if (usr === null || usr.id === user.id) {
        setIsSubscribed(false);
      }

      const obj = { subscribe: false, user_id: usr === null ? user.id : usr.id };
      await post(url.POST_TICKET_SUBSCRIPTION.replace(':id', id), obj);

      setRefresh(refresh + 1);
    } catch (err) {
      setError(`${err.message}: ${err.response.data}`);
      setIsSubscribed(true);
    }
  };

  const subscribe = async (usr = null) => {
    try {
      if (usr === null || usr.id === user.id) {
        if (isSubscribed) return; // already subscribed
        setIsSubscribed(true);
      }

      const obj = { subscribe: true, user_id: usr === null ? user.id : usr.id };
      await post(url.POST_TICKET_SUBSCRIPTION.replace(':id', id), obj);

      setRefresh(refresh + 1);
    } catch (err) {
      setError(`${err.message}: ${err.response.data}`);
      setIsSubscribed(false);
    }
  };

  const sendMessage = async (message) => {
    await subscribe();

    let msg = message;
    if (msg.trim() === '') {
      msg = response;
    }

    // nl2br
    msg = msg.replace(/(\r\n|\r|\n)/g, '<br />');

    // replace URLs with link
    msg = msg.replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1">$1</a>');

    // replace image and file shortcodes with links
    for (let i = 0; i < pendingFiles.length; i += 1) {
      msg = msg.replace(`{{image ${i + 1}}}`, `<a href="${pendingFiles[i]}">${pendingFiles[i]}</a>`);
      msg = msg.replace(`{{file link ${i + 1}}}`, `<a href="${pendingFiles[i]}">${pendingFiles[i]}</a>`);
    }

    try {
      setLoadingMessage(true);

      const msgs = messages;
      msgs.push({
        from: `${user.display_name} <${user.email}>`,
        message: msg,
        created_at: (new Date()).toISOString(),
        attachments: [],
      });

      setMessages(msgs);

      await post(url.POST_TICKET_MESSAGE.replace(':id', id), { message: msg });

      setMessageText('');
      setPendingFiles([]);
      textareaRef.current.focus();
    } catch (err) {
      setError(`${err.message}: ${err.response.data}`);
    } finally {
      setLoadingMessage(false);
    }
  };

  const save = async (ent) => {
    try {
      const obj = ent;
      delete obj.messages;

      await post(url.POST_TICKET, obj);

      setRefresh(refresh + 1);
    } catch (err) {
      setError(`${err.message}: ${err.response.data}`);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const getUsers = (tag) => {
    const fetchData = async () => {
      try {
        const ents = await get(`${url.GET_USERS}?q=${tag}`);

        setUsers(ents.results);
      } catch (e) {
        setError(e.message);
      }
    };

    fetchData();
  };

  const showAttachment = (attachmentId) => {
    const fetchData = async () => {
      try {
        const att = await get(url.GET_TICKET_MESSAGE_ATTACHMENT.replace(':id', attachmentId));

        setAttachment(att);
        setAttachmentModal(true);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoadingAttachment(false);
      }
    };

    setLoadingAttachment(attachmentId);
    fetchData();
  };

  const checkForMessages = () => {
    const fetchData = async () => {
      try {
        const msgs = await get(`${url.GET_TICKET_MESSAGES.replace(':id', data.id)}`);

        msgs.unshift({
          message: data.notes,
          from: `${data.name} from ShopJimmy.com`,
          created_at: data.created_at,
          attachments: [],
        });
        setMessages(msgs);
      } catch (e) {
        toastr.warning(`${t('Could not get new messages')}: ${e.message}`);
        setError(e.message);
      } finally {
        setLoadingMessage(false);
      }
    };

    setLoadingMessage(true);
    fetchData();
  };

  const useTag = (usr) => {
    setMessageText(textareaRef.current.value.replace(/@[^@]+$/, `${usr.display_name} `));
    subscribe(usr);
    setIsTagOpen(false);
  };

  const ValidationSchema = Yup.object().shape({
    subject: Yup.string(),
  });

  const deleteTicket = () => {
    const execute = async () => {
      try {
        await post(`${url.POST_DELETE_TICKET.replace(':id', data.id)}`);

        toastr.success(t(`Successfully deleted Ticket ID #${data.id}`));
        history.push('/customer-service/tickets');
      } catch (e) {
        toastr.warning(`${t('Could not get new messages')}: ${e.message}`);
        setError(e.message);
      } finally {
        setLoadingMessage(false);
      }
    };

    execute();
  };

  return (
    <div className="page-content">
      <Breadcrumbs title="Tickets" prevLink="/customer-service/tickets" breadcrumbItem={`Manage Ticket ID ${id}`} />

      <div className="container-fluid">
        <Row>
          <Col md="5">
            <Card>
              <CardBody>
                <CardTitle className="h4">{t('Ticket')}</CardTitle>
                {error !== null && (
                  <p className="text-danger">{error}</p>
                )}
                {error === null && (
                  <div>
                    <table className="table table-bordered table-striped responsiveTable mt-3">
                      <tbody>
                        <tr>
                          <th>{t('ID')}</th>
                          <td>{loading === true ? t('Loading...') : data.id}</td>
                        </tr>
                        <tr>
                          <th>{t('Name')}</th>
                          <td>{loading === true ? t('Loading...') : data.name}</td>
                        </tr>
                        <tr>
                          <th>{t('Email')}</th>
                          <td>{loading === true ? t('Loading...') : data.email}</td>
                        </tr>
                        <tr>
                          <th>{t('Brand')}</th>
                          <td>{loading === true ? t('Loading...') : data.brand}</td>
                        </tr>
                        <tr>
                          <th>{t('Model')}</th>
                          <td>{loading === true ? t('Loading...') : data.model}</td>
                        </tr>
                        <tr>
                          <th>{t('Version')}</th>
                          <td>{loading === true ? t('Loading...') : data.version}</td>
                        </tr>
                        <tr>
                          <th>{t('Serial')}</th>
                          <td>{loading === true ? t('Loading...') : data.serial}</td>
                        </tr>
                        <tr>
                          <th>{t('Symptoms')}</th>
                          <td>{loading === true ? t('Loading...') : data.symptoms}</td>
                        </tr>
                        <tr>
                          <th>{t('Subject')}</th>
                          <td>{loading === true ? t('Loading...') : data.subject}</td>
                        </tr>
                        <tr>
                          <th>{t('Subscribers')}</th>
                          <td>
                            {subscribers.map((x) => (
                              <span key={`sub_${x.id}`} className="badge bg-success me-2" style={{ fontSize: '14px' }}>
                                {x.display_name}
                                <Button
                                  className="btn-link p-0"
                                  onClick={() => { unsubscribe(x); }}
                                  style={{
                                    fontSize: '14px',
                                    padding: '0.35em 0.35em',
                                    color: '#fff',
                                  }}
                                >
                                  <span className="mdi mdi-close-thick" />
                                </Button>
                              </span>
                            ))}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <Row>
                      <Col xl="12">
                        {isSubscribed === false && (
                          <Button color="primary" onClick={() => { subscribe(); }}>
                            <span className="mdi mdi-account-check" />
                            {' '}
                            {t('Subscribe')}
                          </Button>
                        )}
                        {isSubscribed === true && (
                          <Button color="danger" onClick={() => { unsubscribe(); }}>
                            <span className="mdi mdi-account-cancel" />
                            {' '}
                            {t('Unsubscribe')}
                          </Button>
                        )}

                        <Can i="delete" this="TechSupport">
                          <Button color="danger" className="float-end" onClick={() => { deleteTicket(); }}>
                            <span className="mdi mdi-close-thick" />
                            {' '}
                            {t('Delete')}
                          </Button>
                        </Can>
                      </Col>
                    </Row>
                  </div>
                )}
              </CardBody>
            </Card>

            <Card>
              <CardBody>
                <CardTitle className="h4">{t('Edit')}</CardTitle>
                {error === null && data !== null && (
                <Formik
                  enableReinitialize
                  initialValues={data}
                  validationSchema={ValidationSchema}
                  onSubmit={(values) => {
                    save(values);
                  }}
                >
                  {({
                    touched, errors, setFieldValue, values,
                  }) => (
                    <Form className="mt-3" id="saveForm" autoComplete="off">
                      <div className="row mt-4 mb-4">
                        <Label
                          for="email"
                          className="col-sm-3 col-form-label"
                        >
                          {props.t('Customer Email')}
                        </Label>
                        <Col sm={9}>
                          <Field
                            type="text"
                            className={`form-control ${(errors.email && touched.email ? 'is-invalid' : '')}`}
                            id="email"
                            name="email"
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="invalid-feedback"
                          />
                        </Col>
                      </div>
                      <div className="row mt-4 mb-4">
                        <Label
                          for="subject"
                          className="col-sm-3 col-form-label"
                        >
                          {props.t('Subject')}
                        </Label>
                        <Col sm={9}>
                          <Field
                            type="text"
                            className={`form-control ${(errors.subject && touched.subject ? 'is-invalid' : '')}`}
                            id="subject"
                            name="subject"
                          />
                          <ErrorMessage
                            name="subject"
                            component="div"
                            className="invalid-feedback"
                          />
                        </Col>
                      </div>
                      <div className="row mt-4 mb-4">
                        <Label
                          for="notes"
                          className="col-sm-3 col-form-label"
                        >
                          {props.t('Details')}
                        </Label>
                        <Col sm={9}>
                          <Field
                            as="textarea"
                            className={`form-control ${(errors.notes && touched.notes ? 'is-invalid' : '')}`}
                            id="notes"
                            name="notes"
                          />
                          <ErrorMessage
                            name="notes"
                            component="div"
                            className="invalid-feedback"
                          />
                        </Col>
                      </div>
                      <div className="row mt-4 mb-4">
                        <Label
                          for="brand"
                          className="col-sm-3 col-form-label"
                        >
                          {props.t('Brand')}
                        </Label>
                        <Col sm={9}>
                          <Field
                            type="text"
                            className={`form-control ${(errors.brand && touched.brand ? 'is-invalid' : '')}`}
                            id="brand"
                            name="brand"
                          />
                          <ErrorMessage
                            name="brand"
                            component="div"
                            className="invalid-feedback"
                          />
                        </Col>
                      </div>
                      <div className="row mt-4 mb-4">
                        <Label
                          for="model"
                          className="col-sm-3 col-form-label"
                        >
                          {props.t('Model')}
                        </Label>
                        <Col sm={9}>
                          <Field
                            type="text"
                            className={`form-control ${(errors.model && touched.model ? 'is-invalid' : '')}`}
                            id="model"
                            name="model"
                          />
                          <ErrorMessage
                            name="model"
                            component="div"
                            className="invalid-feedback"
                          />
                        </Col>
                      </div>
                      <div className="row mt-4 mb-4">
                        <Label
                          for="version"
                          className="col-sm-3 col-form-label"
                        >
                          {props.t('Version')}
                        </Label>
                        <Col sm={9}>
                          <Field
                            type="text"
                            className={`form-control ${(errors.version && touched.version ? 'is-invalid' : '')}`}
                            id="version"
                            name="version"
                          />
                          <ErrorMessage
                            name="version"
                            component="div"
                            className="invalid-feedback"
                          />
                        </Col>
                      </div>
                      <div className="row mt-4 mb-4">
                        <Label
                          for="serial"
                          className="col-sm-3 col-form-label"
                        >
                          {props.t('Serial')}
                        </Label>
                        <Col sm={9}>
                          <Field
                            type="text"
                            className={`form-control ${(errors.serial && touched.serial ? 'is-invalid' : '')}`}
                            id="serial"
                            name="serial"
                          />
                          <ErrorMessage
                            name="serial"
                            component="div"
                            className="invalid-feedback"
                          />
                        </Col>
                      </div>
                      <div className="form-check">
                        <label htmlFor="concluded" className="form-check-label">{t('Concluded')}</label>
                        <Field
                          type="checkbox"
                          className="form-check-input"
                          id="concluded"
                          name="concluded"
                          value="1"
                          onChange={(e) => {
                            setFieldValue('status', e.target.checked ? 1 : 0);
                          }}
                          checked={values.status === 1}
                        />
                      </div>
                      <div className="form-check">
                        <label htmlFor="frontend" className="form-check-label">{t('Website Worthy?')}</label>
                        <Field
                          type="checkbox"
                          className="form-check-input"
                          id="frontend"
                          name="frontend_worthy"
                          value="1"
                          onChange={(e) => {
                            setFieldValue('frontend_worthy', e.target.checked ? 1 : 0);
                          }}
                          checked={values.frontend_worthy === 1}
                        />
                      </div>
                      <h5 className="mt-4 mb-4">Skus</h5>
                      <FieldArray name="items" className="mt-3">
                        {(arrayHelpers) => (
                          <div className="mt-3">
                            <Button color="info" size="sm" onClick={() => { arrayHelpers.push({ sku: '' }); }}>{t('Add Sku +')}</Button>
                            {values.items.map((x, i) => (
                              <Row key={`item_${i}`} className="mt-4 mb-4">
                                <Col xxl="6">
                                  <InputGroup>
                                    <Field
                                      type="text"
                                      className="form-control"
                                      id={`item_sku_${i}`}
                                      name={`items[${i}].sku`}
                                      normalize={(value) => (value ? value.trim() : '')}
                                    />
                                    <Button color="danger" onClick={() => { arrayHelpers.remove(i); }}>
                                      <span className="mdi mdi-close-thick" />
                                    </Button>
                                  </InputGroup>
                                  <ErrorMessage
                                    name={`items[${i}].sku`}
                                    component="div"
                                    className="text-danger pt-2"
                                  />
                                </Col>
                              </Row>
                            ))}
                          </div>
                        )}
                      </FieldArray>
                      <div className="row justify-content-end">
                        <Col sm={9}>
                          <div className="d-flex flex-row-reverse bd-highlight gap-2">
                            <Button
                              type="submit"
                              form="saveForm"
                              color="primary"
                              className="w-md btn-soft-primary"
                            >
                              {props.t('Save')}
                            </Button>
                          </div>
                        </Col>
                      </div>
                    </Form>
                  )}
                </Formik>
                )}
              </CardBody>
            </Card>
          </Col>

          <Col md="7">
            <div className="w-100 user-chat">
              <Card>
                <div className="p-4 border-bottom ">
                  <Row>
                    <Col md="4" xs="9">
                      <h5 className="font-size-15 mb-1">
                        {data !== null && data.name}
                      </h5>
                    </Col>
                    <Col md="8" xs="3">
                      <ul className="list-inline user-chat-nav text-end mb-0">
                        <div />
                      </ul>
                    </Col>
                  </Row>
                </div>
                <div>
                  <div className="chat-conversation p-3">
                    <ul className="list-unstyled">
                      <PerfectScrollbar
                        style={{ minHeight: '470px' }}
                        containerRef={(ref) => setMessageBox(ref)}
                      >
                        {messages.map((message) => (
                          <li
                            key={`test_k ${message.id}`}
                            className={
                              message.from.includes(user.email)
                                ? 'right'
                                : ''
                            }
                          >
                            <div className="conversation-list">
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  href="#"
                                  tag="a"
                                  className="dropdown-toggle"
                                >
                                  <i className="bx bx-dots-vertical-rounded" />
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem onClick={(e) => copyMsg(e.target)} href="#">
                                    Copy
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                              <div className="ctext-wrap" style={message.from.toLowerCase().includes(data.email.toLowerCase()) ? { backgroundColor: '#e7cbdb' } : {}}>
                                <div className="conversation-name">
                                  {message.from}
                                </div>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: sanitizeTicketHtml(message.message),
                                  }}
                                />
                                {message.attachments.length > 0 && message.attachments.map((x) => (
                                  <div>
                                    <span className="bx bx-image-alt" />
                                    {' '}
                                    <a href="#" onClick={(e) => { e.preventDefault(); showAttachment(x.attachment_id); }}>{x.name}</a>
                                    {' '}
                                    <span className="text-dark">
                                      {`(${Math.ceil(Number(x.size) / 1000)} KB)`}
                                    </span>
                                    {loadingAttachment === x.attachment_id && (
                                      <span className="text-dark">
                                        {' '}
                                        <span className="mdi mdi-loading mdi-spin" />
                                        {' '}
                                        {t('Loading')}
                                      </span>
                                    )}
                                  </div>
                                ))}
                                <p className="chat-time mb-0 mt-2">
                                  <i className="bx bx-time-five align-middle me-1" />
                                  {moment(message.created_at).fromNow()}
                                </p>
                              </div>
                            </div>
                          </li>
                        ))}
                      </PerfectScrollbar>
                    </ul>
                  </div>
                  <div className="p-3 chat-input-section">
                    <div className="position-relative flex-fill">
                      <textarea
                        ref={textareaRef}
                        className="form-control chat-input"
                        placeholder={response}
                        onDoubleClick={() => {
                          if (messageText === '') {
                            textareaRef.current.innerHTML = response;
                          }
                        }}
                        onInput={(e) => {
                          setMessageText(e.target.value);
                          const cursorPosition = e.target.selectionStart;
                          const text = e.target.value.substr(0, cursorPosition);
                          const pattern = /@([a-zA-Z0-9-]+)$/;
                          if (pattern.test(text)) {
                            setIsTagOpen(true);
                            const tag = text.match(pattern)[1];

                            getUsers(tag);
                          } else {
                            setIsTagOpen(false);
                          }
                        }}
                        rows="5"
                        style={{ borderRadius: '15px' }}
                        value={messageText}
                      />
                      {users.length > 0 && (
                        <UncontrolledDropdown isOpen={isTagOpen} toggle={toggleTagDropdown}>
                          <DropdownMenu className="dropdown-menu-md p-3">
                            {users.map((x) => (
                              <a href="#" onClick={() => { useTag(x); textareaRef.current.focus(); }}>
                                <div className="hstack gap-2">
                                  <div>{x.display_name}</div>
                                  <div className="text-dark">{`@${x.name}`}</div>
                                </div>
                              </a>
                            ))}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      )}
                    </div>
                    <Row>
                      <Col md="6">
                        <div className="pt-3 pb-3 d-flex justify-content-start">
                          <Button color="warning" className="me-3 btn-soft-warning text-dark" onClick={() => { checkForMessages(); }}>
                            <span className={`mdi mdi-comment-eye ${loadingMessage ? 'mdi-spin' : ''}`} />
                            {' '}
                            {loadingMessage ? t('Checking for Messages') : t('Check for Messages')}
                          </Button>
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="pt-3 pb-3 d-flex justify-content-end">
                          <Button
                            type="button"
                            color="light"
                            className="btn btn-light btn-rounded me-3 position-relative"
                            onClick={() => { setFileCollapse(!fileCollapse); }}
                          >
                            <span className="mdi mdi-attachment" style={{ fontSize: '22px' }} />
                            {pendingFiles.length > 0 && (
                              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
                                {pendingFiles.length}
                              </span>
                            )}
                          </Button>
                          <Button
                            type="button"
                            onClick={() => { sendMessage(messageText); }}
                            color="primary"
                            disabled={loadingMessage}
                            className="btn btn-primary btn-rounded chat-send w-md"
                          >
                            {loadingMessage === false && (
                              <span className="d-none d-sm-inline-block me-2">
                                {t('Send')}
                              </span>
                            )}
                            {loadingMessage === true && (
                              <span className="d-none d-sm-inline-block me-2">
                                <span className="mdi mdi-spin mdi-loading" />
                                {' '}
                                {t('Pending')}
                              </span>
                            )}
                            {' '}
                            <i className="mdi mdi-send" />
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <Collapse isOpen={fileCollapse}>
                      <GoogleFiles
                        // eslint-disable-next-line no-unused-vars
                        onFileUpload={(pubUrl) => {
                          const files = pendingFiles;
                          files.push(pubUrl);
                          setPendingFiles(files);
                          setFileCollapse(false);

                          if (pubUrl.match(/\.(jpe?g|png)$/)) {
                            setMessageText(`${messageText} {{image ${pendingFiles.length}}}`);
                          } else {
                            setMessageText(`${messageText} {{file link ${pendingFiles.length}}}`);
                          }

                          textareaRef.current.focus();
                        }}
                        bucket="tech_support_files"
                      />
                    </Collapse>
                  </div>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>

      <Modal
        size="lg"
        isOpen={attachmentModal}
      >
        <div className="modal-header">
          <h5
            className="modal-title mt-0"
            id="attachment_modal"
          >
            {attachment.name}
          </h5>
          <button
            onClick={() => { setAttachmentModal(false); }}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <img className="rounded me-2 img-fluid" alt={`${attachment.name}`} src={`data:${attachment.contentType};base64, ${attachment.contentBytes}`} />
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => { setAttachmentModal(false); }}
            className="btn btn-soft-dark"
            data-dismiss="modal"
          >
            {t('Close')}
          </button>
        </div>
      </Modal>
    </div>
  );
}

Ticket.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Ticket));
